var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { P, PCSS, CustomElement, Watch, ViewChild, Components, Utils, PropertyConverters, UI, Animations } from '@pacem/pacem-core';
import { Angle } from '@pacem/pacem-foundation';
//namespace Pacem.Components.UI {
const TWO_PI = Math.PI * 2;
function cartesian(cx, cy, r, theta) {
    return {
        x: cx + (r * Math.cos(theta)),
        y: cy + (r * Math.sin(theta))
    };
}
let PacemTunerElement = class PacemTunerElement extends Components.PacemElement {
    constructor() {
        super();
        //#region INTERACTIVE
        this.min = 0.0;
        this.max = 100.0;
        this._rotateStartHandler = (evt) => {
            const angle = this.#angle = this._getAngle(evt);
            const r = this._rotate;
            r.minRotation = 0 - angle;
            r.maxRotation = TWO_PI - angle;
            this._setValue(angle);
        };
        this._rotateEndHandler = (evt) => {
            //this.#angle += evt.detail.rotation;
        };
        this._rotateHandler = (evt) => {
            evt.preventDefault();
            const angle = evt.detail.rotation + this.#angle;
            this._setValue(angle);
        };
    }
    #angle;
    viewActivatedCallback() {
        super.viewActivatedCallback();
        const rotate = this._rotate, tween = this._tween;
        rotate.addEventListener(UI.RotateEventType.Start, this._rotateStartHandler, false);
        rotate.addEventListener(UI.RotateEventType.Rotate, this._rotateHandler, false);
        rotate.addEventListener(UI.RotateEventType.End, this._rotateEndHandler, false);
        rotate.register(this._canvas);
        this._toggleRotate();
        //
        requestAnimationFrame(() => this._draw(this.min));
        //
        tween.easing = Animations.Easings.sineInOut;
        tween.delay = 500 + (Math.random() * 100 - 100);
        tween.start = this.value > this.min;
    }
    disconnectedCallback() {
        const rotate = this._rotate, canvas = this._canvas;
        if (!Utils.isNull(rotate)) {
            rotate.removeEventListener(UI.RotateEventType.Rotate, this._rotateHandler, false);
            if (!Utils.isNull(canvas)) {
                rotate.unregister(canvas);
            }
        }
        super.disconnectedCallback();
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        switch (name) {
            case 'interactive':
                this._toggleRotate(val);
                if (!val)
                    Utils.removeClass(this, 'tuner-interactive');
                else
                    Utils.addClass(this, 'tuner-interactive');
                break;
            case 'round':
                if (Math.round(val) != val || val < 0)
                    throw `${this.constructor.name}: round value must be an integer greater or equal to zero.`;
                break;
            default:
                // in any other case:
                this._draw();
                break;
        }
    }
    _toggleRotate(interactive = this.interactive) {
        const r = this._rotate;
        if (!Utils.isNull(r)) {
            r.disabled = !interactive;
        }
    }
    _angleToValue(angle) {
        const round = Math.pow(10, this.round || 0);
        const angleValue = this.min + angle * (this.max - this.min) / TWO_PI;
        return Math.round(round * angleValue) / round;
    }
    _valueToAngle(v = this.value ?? this.min) {
        return TWO_PI * (v - this.min) / (this.max - this.min);
    }
    _setValue(angle) {
        const value = this._angleToValue(angle).clamp(this.min, this.max);
        if (value != this.value) {
            this.value = value;
            this.dispatchEvent(new Event("change"));
        }
    }
    /**
     * Returns the angle between the vertical line through 'center' and the line through 'center' and 'currentPosition'.
     * @param evt
     * @returns
     */
    _getAngle(evt) {
        const angle = {
            vertex: evt.detail.center,
            end: evt.detail.currentPosition,
            start: { x: evt.detail.center.x, y: evt.detail.center.y - 1 }
        };
        const alpha = Angle.value(angle);
        if (alpha > 0) {
            return TWO_PI - alpha;
        }
        else {
            return -alpha;
        }
    }
    //#endregion
    _draw(value = this.value) {
        if (this.disabled || Utils.isNull(this._rail)) {
            return;
        }
        value = (isNaN(value) ? this.min : value).clamp(this.min, this.max);
        const rail = this._rail;
        const counterRail = this._counterRail;
        const isMin = value === this.min, isMax = value === this.max;
        if (isMin || isMax) {
            const d = `M 50 50 m -50,0 a 50,50 0 1,1 100,0 a 50,50 0 1,1 -100,0`;
            rail.setAttribute('d', isMin ? '' : d);
            counterRail.setAttribute('d', isMax ? '' : d);
        }
        else {
            const mathPI2 = Math.PI * .5;
            // rail
            const from = cartesian(50, 50, 50, -mathPI2);
            const angle /* fraction of the round angle */ = this._valueToAngle(value);
            const to = cartesian(50, 50, 50, -mathPI2 + angle);
            const large = angle > Math.PI ? 1 : 0;
            const d = `M ${to.x} ${to.y} A 50 50 0 ${large} 0 ${from.x} ${from.y}`;
            rail.setAttribute('d', d);
            // counter rail
            const counterFrom = to;
            const counterTo = cartesian(50, 50, 50, 3 * mathPI2);
            const counterAngle /* fraction of the round angle */ = this._valueToAngle(this.max - value);
            const counterLarge = counterAngle > Math.PI ? 1 : 0;
            const counterD = `M ${counterTo.x} ${counterTo.y} A 50 50 0 ${counterLarge} 0 ${counterFrom.x} ${counterFrom.y}`;
            counterRail.setAttribute('d', counterD);
        }
    }
};
__decorate([
    ViewChild('svg')
], PacemTunerElement.prototype, "_canvas", void 0);
__decorate([
    ViewChild('path[part=rail]')
], PacemTunerElement.prototype, "_rail", void 0);
__decorate([
    ViewChild('path[part=complementary-rail]')
], PacemTunerElement.prototype, "_counterRail", void 0);
__decorate([
    ViewChild(P + '-tween')
], PacemTunerElement.prototype, "_tween", void 0);
__decorate([
    ViewChild(P + '-rotate')
], PacemTunerElement.prototype, "_rotate", void 0);
__decorate([
    Watch({ converter: PropertyConverters.Number })
], PacemTunerElement.prototype, "value", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Number })
], PacemTunerElement.prototype, "min", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Number })
], PacemTunerElement.prototype, "max", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Boolean })
], PacemTunerElement.prototype, "interactive", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Number })
], PacemTunerElement.prototype, "round", void 0);
PacemTunerElement = __decorate([
    CustomElement({
        tagName: P + '-tuner', shadow: true,
        template: `<svg xmlns="http://www.w3.org/2000/svg" class="${PCSS}-tuner" part="tuner" viewBox="0 0 100 100">
            <circle part="track" cx="50" cy="50" r="50" />
            <path part="rail" />
            <path part="complementary-rail" />
        </svg><div class="${PCSS}-content" part="content"><slot></slot></div>
        <${P}-rotate></${P}-rotate>
<${P}-tween on-step=":host._draw($event.detail.value)" on-end="this.disabled = true" duration="500" to="{{ :host.value }}" from="{{ :host.min }}"></${P}-tween>`
    })
], PacemTunerElement);
export { PacemTunerElement };
